export default function useInterval(tick: () => void, time: number) {
  const timer = ref<NodeJS.Timer | null>(null)
  const intervalTime = ref(time)
  const intervalFunc = ref(tick)
  const state = ref(false)

  watch(
    () => intervalFunc.value,
    () => {
      if (!intervalFunc && timer.value) clearInterval(timer.value)
    }
  )

  const start = () => {
    if (!state.value) {
      timer.value = setInterval(() => {
        intervalFunc.value()
      }, intervalTime.value)
      state.value = true
    }
  }

  const stop = () => {
    if (state.value && timer.value) {
      clearInterval(timer.value)
      state.value = false
    }
  }

  const restart = () => {
    stop()
    start()
  }

  return {
    start,
    stop,
    restart,
  }
}
